import Typography from "ds/components/Typography";

import ChangeHistoryCardSeparator from "./Separator";
import ChangeHistoryCardTimeLabel from "./TimeLabel";

type ChangeHistoryCardMultipleInputsSummaryProps = {
  inputCount: number;
  timeLabel: string;
};

const ChangeHistoryCardMultipleInputsSummary = ({
  inputCount,
  timeLabel,
}: ChangeHistoryCardMultipleInputsSummaryProps) => (
  <>
    <Typography tag="span" variant="p-t7">
      {inputCount}
    </Typography>
    <Typography tag="span" variant="p-body3" color="secondary">
      inputs
    </Typography>
    <ChangeHistoryCardSeparator />
    <ChangeHistoryCardTimeLabel timeLabel={timeLabel} />
  </>
);

export default ChangeHistoryCardMultipleInputsSummary;
